import type React from 'react'
import { forwardRef } from 'react'
import { useResolveText } from '../i18n'

export interface WithPlaceholder {
  placeholder?: string
  placeholderTid?: string
  placeholderValues?: Record<string, unknown>
}

/**
 * Resolves `placeholderTid` (i18n key) to a string and forwards it as `placeholder`.
 * If no `placeholderTid` is provided, `placeholder` is forwarded unchanged.
 */
export const withPlaceholder = <P extends { placeholder?: string }>(WrappedComponent: React.ComponentType<P>) => {
  const ComponentWithPlaceholder = forwardRef<unknown, P & WithPlaceholder>(({ placeholder, placeholderTid, placeholderValues, ...props }, ref) => {
    const resolve = useResolveText()
    const resolved = resolve(placeholderTid, placeholder, placeholderValues)
    return <WrappedComponent ref={ref} {...(props as unknown as P)} placeholder={resolved} />
  })
  ComponentWithPlaceholder.displayName = `WithPlaceholder-${WrappedComponent.displayName || 'Wrapped'}`
  return ComponentWithPlaceholder
}
